import { EVENT_TYPES } from "@/lib/events";

const Tile = ({ t, i, count, disabled, onPick }) => (
  <button data-testid={`btn-event-${t.key}`} disabled={disabled} onClick={() => onPick(t.key)}
    style={{ animationDelay: `${i * 40}ms` }}
    className="rise tap group relative min-h-[76px] sm:min-h-[96px] pl-3 sm:pl-5 pr-2 sm:pr-3 pt-2 sm:pt-3 pb-7 sm:pb-9 text-left border border-white/15 bg-[#131313] hover:border-white/40 disabled:brightness-[.35] disabled:pointer-events-none overflow-hidden">
    <span className="absolute left-0 top-0 bottom-0 w-1 sm:w-1.5" style={{ background: t.color }} />
    <span className="block font-display text-[15px] sm:text-xl font-bold uppercase leading-tight break-words hyphens-auto">{t.label}</span>
    <span data-testid={`count-event-${t.key}`} className="absolute right-2 sm:right-3 bottom-0.5 sm:bottom-1 font-display text-2xl sm:text-3xl font-bold text-white/25 group-hover:text-white/60 tabular-nums">
      {count}
    </span>
  </button>
);

const GROUPS = [
  { key: "disc", title: "Disciplina · com observação", cols: "grid-cols-3 sm:grid-cols-4" },
  { key: "jogo", title: "Jogo", cols: "grid-cols-3 sm:grid-cols-4" },
];

export const EventGrid = ({ match, disabled, onlyKeys, hint, onPick }) => (
  <section className="space-y-6">
    <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1">
      <h2 className="font-display text-2xl font-bold uppercase">Registar evento</h2>
      {disabled && <span data-testid="events-disabled-hint" className="text-sm text-zinc-500">Inicie o cronómetro para registar</span>}
      {onlyKeys && <span data-testid="events-halftime-hint" className="text-sm text-[#5AC8FA]">{hint}</span>}
    </div>
    {GROUPS.map((g) => (
      <div key={g.key} data-testid={`event-group-${g.key}`}>
        <p className="label-caps mb-2">{g.title}</p>
        <div className={`grid ${g.cols} gap-2 sm:gap-3`}>
          {EVENT_TYPES.filter((t) => t.group === g.key).map((t, i) => (
            <Tile key={t.key} t={t} i={i} disabled={disabled || (onlyKeys && !onlyKeys.includes(t.key))} onPick={onPick} count={match.events.filter((e) => e.type === t.key).length} />
          ))}
        </div>
      </div>
    ))}
  </section>
);
